export * from './auth.guard';



// WEBPACK FOOTER //
// ./src/app/shared/guard/index.ts